import React from 'react'
import './style.css'
import Button from '../../CtaButton'
import AuraButtonGreen from '../AuraButton/AuraButtonGreen'

const AuraIntigration = () => {
    return (
        <>
            <section className="aura-integration-section">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-7 col-md-12">
                            <h2 className="aura-section-heading">Connect with the systems <br /> your clinic already uses</h2>
                            <p className="description-text">Aura Clinic integrates seamlessly with leading clinical software, appointment tools, and secure data sources enhancing your existing workflows without requiring major changes to your practice.</p>
                        </div>

                        <div className="col-xl-5 col-lg-5 col-md-12">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/best-practice.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/cliniko.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/mbs.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/medical-director.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/twilio.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/xero.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/medicare-icon.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>

                                    <div className="col-6 col-sm-4 col-md-4 col-lg-4 text-center mt-3">
                                        <div className="aura-intigration-icon-box">
                                            <img src="/images/aura-clinic-icons/zedmed.png" alt="Integration 1" className="img-fluid aura-integration-img" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AuraIntigration